<div id="offline-container">
  <img src="/assets/customer-assets/no-network-connection.svg" />

  <h1>Hoppla!</h1>
  <p>
    Es scheint ein Problem mit Ihrer Internetverbindung zu geben.<br />
    Bitte stellen Sie sicher, dass Ihr Gerät mit einem WLAN-Netzwerk oder den Mobilen Daten verbunden ist.
  </p>
</div>
